import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

const {
  VITE_FIREBASE_API_KEY,
  VITE_FIREBASE_AUTH_DOMAIN,
  VITE_FIREBASE_PROJECT_ID,
  VITE_FIREBASE_STORAGE_BUCKET,
  VITE_FIREBASE_MESSAGING_SENDER_ID,
  VITE_FIREBASE_APP_ID,
  VITE_FIREBASE_MEASUREMENT_ID,
} = import.meta.env;
const firebaseConfig = {
  apiKey: VITE_FIREBASE_API_KEY,
  authDomain: VITE_FIREBASE_AUTH_DOMAIN,
  projectId: VITE_FIREBASE_PROJECT_ID,
  storageBucket: VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: VITE_FIREBASE_APP_ID,
  measurementId: VITE_FIREBASE_MEASUREMENT_ID,
};
let messaging: Messaging | null = null;

if ('serviceWorker' in navigator) {
  // Initialize Firebase
  const app = initializeApp(firebaseConfig);

  getAnalytics(app);

  try {
    /**
     * metadata:
     * - feature: firebase.messaging-safe-bootstrap
     * - purpose: mantener la app operativa cuando el navegador tiene service worker pero no soporta Firebase Messaging
     */
    messaging = getMessaging(app);
  } catch (error) {
    console.warn('Firebase Messaging is not available in this browser.', error);
  }
} else {
  console.log('Service Workers are not supported in this environment.');
}

export { messaging };
